import { RangePickerDateProps } from 'antd/es/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import DatePicker from './DatePicker';

export type RangePickerProps = RangePickerDateProps<Dayjs>;

export default DatePicker.RangePicker;
